import React, { useState, useEffect } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Label,
} from "reactstrap";
import { getUsers } from '../../../../services/users';
import { updateGroupConversation } from '../../../../services/conversations';

export default function InviteUserModal({ isOpen, toggle, chatDetails, addMemberHandler }) {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");

  const fetchUsers = async () => {
    if (!chatDetails?.members) return;

    try {
      const { data: allUsers } = await getUsers();
      const memberIds = new Set(chatDetails.members.map(member => String(member._id)));

      const filteredUsers = allUsers.filter(user => !memberIds.has(String(user._id)));
      setUsers(filteredUsers);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const handleInviteUser = async () => {
    if (!selectedUser) return;

    const updatedMemberIds = [
      ...chatDetails.members.map(member => String(member._id)),
      selectedUser
    ];

    const invitedUser = users.find(user => user._id === selectedUser);
    if (!invitedUser) {
      console.warn("Selected user not found in user list.");
      return;
    }

    try {
      await updateGroupConversation(chatDetails._id, { members: updatedMemberIds });

      // Optimistically update local state
      addMemberHandler(invitedUser);
      setUsers(prev => prev.filter(user => user._id !== selectedUser));
      setSelectedUser("");
      toggle();
    } catch (error) {
      console.error("Failed to invite user:", error);
    }
  };


  useEffect(() => {
    if (isOpen && chatDetails?.members) {
      fetchUsers();
    }
  }, [isOpen, chatDetails]);

  return (
    <Modal isOpen={isOpen} centered toggle={toggle}>
      <ModalHeader tag="h5" className="font-size-16">
        Add/Invite User
      </ModalHeader>
      <ModalBody className="p-4">
        <Form>
          <div className="mb-4">
            <Label className="form-label" htmlFor="user-select">
              Users
            </Label>
            <select
              id="user-select"
              name="users"
              value={selectedUser}
              className="form-control"
              onChange={(e) => setSelectedUser(e.target.value)}
            >
              <option value="" disabled>Select User</option>
              {users.map((user) => (
                <option key={user._id} value={user._id}>
                  {user.contactName.first} {user.contactName.last}
                </option>
              ))}
            </select>
          </div>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button type="button" color="link" onClick={toggle}>
          Close
        </Button>
        <Button
          type="button"
          color="primary"
          disabled={!selectedUser}
          onClick={handleInviteUser}
        >
          Invite Contact
        </Button>
      </ModalFooter>
    </Modal>
  );
}
